import { APIDirectory, HTTP } from "../../rest"
import { UserProfileActions } from '../userProfile'
import { ErrorLogActions } from '../errorLog'
import store from '../../store';
import theme from '../../assests/theme'
import { resetActiveSchool, getActiveScheduleIndex } from '../../utils/LocalStorageUtil'
import lodash from 'lodash'
import { ScheduleConstants } from '../../components/functional/school/schedule/ScheduleConstants';
export const SCHOOLINFORMATION_IN_PROCESS = "SCHOOLINFORMATION_IN_PROCESS";

export const SCHOOLINFORMATION_COMPLETE = "SCHOOLINFORMATION_COMPLETE";

export const RETRIEVE_SCHOOLIFORMATION_IN_PROGRESS = "RETRIEVESCHOOLIFORMATION_IN_PROGRESS";

export const RETRIEVE_SCHOOLIFORMATION_COMPLETE = "RETRIEVESCHOOLIFORMATION_COMPLETE";

export const SET_ACTIVE_SCHOOL = "SET_ACTIVE_SCHOOL"
export const SET_ACTIVE_SCHEDULE = "SET_ACTIVE_SCHEDULE"

export const SET_IS_CREATE_NEW_SCHOOL = "SET_IS_CREATE_NEW_SCHOOL"

export const SCHOOLINFORMATION_DELETION_IN_PROGRESS = "SCHOOLINFORMATION_DELETION_IN_PROGRESS ";

export const SCHOOLINFORMATION_DELETION_COMPLETE = "SCHOOLINFORMATION_DELETION_COMPLETE";

export const SCHOOL_INFORMATION_UPDATE_IN_PROGRESS = "SCHOOL_INFORMATION_UPDATE_IN_PROGRESS"

export const SCHOOL_INFORMATION_UPDATE_COMPLETE = "SCHOOL_INFORMATION_UPDATE_COMPLETE"
export const UPDATE_NEW_SCHOOL_IN_USER_INFORMATION = "UPDATE_NEW_SCHOOL_IN_USER_INFORMATION"
export const UPDATE_SCHOOL_SCHEDULE_CONSTRAINTS_COMPLETE = "UPDATE_SCHOOL_SCHEDULE_CONSTRAINTS_COMPLETE"
export const DELETE_SCHOOL_IN_PROGRESS = "DELETE_SCHOOL_IN_PROGRESS"
export const DELETE_SCHOOL_COMPLETE = "DELETE_SCHOOL_COMPLETE"

export const schoolInformationUpdateInProgress = () => {
    return {
        type: SCHOOL_INFORMATION_UPDATE_IN_PROGRESS
    }
}

export const schoolInformationUpdateComplete = (school) => {
    return {
        type: SCHOOL_INFORMATION_UPDATE_COMPLETE,
        school: school
    }
}
export const updateSchoolScheduleConstraintsComplete = (data) => {
    return {
        type: UPDATE_SCHOOL_SCHEDULE_CONSTRAINTS_COMPLETE,
        data: data
    }
}
export const schoolInformationDeletionInProgress = () => {
    return {
        type: SCHOOLINFORMATION_DELETION_IN_PROGRESS
    };
};
export const schoolInformationDeletionComplete = (data, schoolList) => {
    return {
        type: SCHOOLINFORMATION_DELETION_COMPLETE,
        data: data,
        schoolList: schoolList

    };
};


export const schoolInformationInProcess = () => {
    return {
        type: SCHOOLINFORMATION_IN_PROCESS
    };
};


export const schoolInformationComplete = data => {
    return {
        type: SCHOOLINFORMATION_COMPLETE,
        data: data
    };
};

export const retrieveSchoolInformationInProgress = () => {
    return {
        type: RETRIEVE_SCHOOLIFORMATION_IN_PROGRESS
    };
};

export const retrieveSchoolInformationComplete = data => {
    return {
        type: RETRIEVE_SCHOOLIFORMATION_COMPLETE,
        data: data
    };
};

export const setActiveSchool = data => {
    return {
        type: SET_ACTIVE_SCHOOL,
        data: data
    };
};

export const setIsCreateNewSchool = data => {
    return {
        type: SET_IS_CREATE_NEW_SCHOOL,
        data: data
    }
}
export const updateNewSchoolInUserInformation = data => {
    return {
        type: UPDATE_NEW_SCHOOL_IN_USER_INFORMATION,
        data: data
    }
}
export const saveSchoolInformation = (ownerId, userData) => {
    return async dispatch => {
        try {
            dispatch(schoolInformationInProcess());
            let url = APIDirectory.createSchoolURL(ownerId);
            let saveSchoolInformationResult = await HTTP.POST(url, JSON.stringify(userData));
            resetActiveSchool(saveSchoolInformation);
            dispatch(schoolInformationComplete(saveSchoolInformationResult));
            dispatch(UserProfileActions.getUserProfileByCognitoId(store.getState().cognito.user.username))
            return saveSchoolInformationResult;
        }
        catch (error) {
            return [];
        }

    };
};


export const editSchoolInformation = (ownerId, schoolId, school) => {

    //temporary code to add color to all existing  subjects & elective

    if (school.school_master.subjects.length > 0 && school.school_master.subjects[0].color == undefined) {
        school.school_master.subjects.map(function (subject, index) {

            if (index >= theme.colorCatalogue.length) {
                subject.color = theme.colorCatalogue[index % theme.colorCatalogue.length]
            }
            else {
                subject.color = theme.colorCatalogue[index]
            }
        })
    }
    if (school.school_master.electives.length > 0 && school.school_master.electives[0].color == undefined) {
        school.school_master.electives.map(function (elective, index) {

            if (index >= theme.colorCatalogue.length) {
                elective.color = theme.colorCatalogue[index % theme.colorCatalogue.length]
            }
            else {
                elective.color = theme.colorCatalogue[index]
            }
        })
    }
    if (school.schedule_constraints !== undefined && school.schedule_constraints.length > 0) {
        school.schedule_constraints.map(function (schedule_constraint, index) {
            if (schedule_constraint.enableGenerateTimeTable === true) {
                schedule_constraint.enableGenerateTimeTable = false;
                schedule_constraint['version'] = schedule_constraint['version'] + 1;
                schedule_constraint.modifiedDate = new Date()
                schedule_constraint.status = ScheduleConstants.INPROGRESS
            }
        })
    }
    return async dispatch => {
        try {
            dispatch(schoolInformationUpdateInProgress());
            let url = APIDirectory.getUpdateSchoolURL(ownerId, schoolId);
            let updatedSchool = await HTTP.PUT(url, JSON.stringify(school));
            resetActiveSchool(updatedSchool);
            dispatch(schoolInformationUpdateComplete(updatedSchool));
            return updatedSchool;
        } catch (error) {
            console.error("Schoolinformation action error ->", error);
            dispatch(schoolInformationUpdateComplete(school));
            return { result: error, status: false };
        }
    }
}
export const updateSchoolScheduleConstraints = (ownerId, schoolId, school, scheduleConstraintsIndex) => {
    return async dispatch => {
        try {
            dispatch(schoolInformationUpdateInProgress());
            let url = APIDirectory.getupdateSchoolScheduleConstraintsURL(ownerId, schoolId);
            
            let response = await HTTP.PUT(url, { scheduleConstraints: school.schedule_constraints[scheduleConstraintsIndex] });
            school = response.school;
            //school.schedule_constraints[scheduleConstraintsIndex] = response.scheduleConstraints
            let index = lodash.findIndex(response.school.schedule_constraints,  ['_id', response.scheduleConstraints['_id']]);
            [response.school.schedule_constraints[index], response.school.schedule_constraints[scheduleConstraintsIndex]] = [response.school.schedule_constraints[scheduleConstraintsIndex], response.school.schedule_constraints[index]];
            
            resetActiveSchool(school);
            dispatch(updateSchoolScheduleConstraintsComplete(school));

            return school;
        } catch (error) {
            console.error("Schoolinformation action error ->", error);
            dispatch(schoolInformationUpdateComplete(school));
            return { result: error, status: false };
        }
    }
}
export const updatedSchoolMaster = (ownerId, schoolId, school) => {

    //temporary code to add color to all existing  subjects & elective

    if (school.school_master.subjects.length > 0 && school.school_master.subjects[0].color == undefined) {
        school.school_master.subjects.map(function (subject, index) {

            if (index >= theme.colorCatalogue.length) {
                subject.color = theme.colorCatalogue[index % theme.colorCatalogue.length]
            }
            else {
                subject.color = theme.colorCatalogue[index]
            }
        })
    }
    if (school.school_master.electives.length > 0 && school.school_master.electives[0].color == undefined) {
        school.school_master.electives.map(function (elective, index) {

            if (index >= theme.colorCatalogue.length) {
                elective.color = theme.colorCatalogue[index % theme.colorCatalogue.length]
            }
            else {
                elective.color = theme.colorCatalogue[index]
            }
        })
    }
    
    return async dispatch => {
        try {
            dispatch(schoolInformationUpdateInProgress());
            let url = APIDirectory.getupdateSchoolMasterURL(ownerId, schoolId);
            let updatedSchool = await HTTP.PUT(url, { schoolMaster: school.school_master, version: school['__v'] });
            resetActiveSchool(updatedSchool);
            dispatch(schoolInformationUpdateComplete(updatedSchool));
            return updatedSchool;
        } catch (error) {
            console.error("Schoolinformation action error ->", error);
            dispatch(schoolInformationUpdateComplete(school));
            return { result: error, status: false };
        }
    }
}
export const getSchoolInformation = (ownerId) => {
    return async dispatch => {
        try {
            dispatch(retrieveSchoolInformationInProgress());
            let url = APIDirectory.createSchoolURL(ownerId);
            let getSchoolInformationResult = await HTTP.GET(url);
            resetActiveSchool(getSchoolInformationResult);
            dispatch(retrieveSchoolInformationComplete(getSchoolInformationResult));

            return getSchoolInformationResult
        }
        catch (error) {
            return [];
        }
    };
};

export const getSchoolInformationByAdminId = (ownerId, adminId) => {

    return async dispatch => {
        try {
            dispatch(retrieveSchoolInformationInProgress());
            let url = APIDirectory.getSchoolInformationByAdminId(ownerId, adminId);
            let getSchoolInformationResult = await HTTP.GET(url);
            resetActiveSchool(getSchoolInformationResult);
            dispatch(retrieveSchoolInformationComplete(getSchoolInformationResult));
            return getSchoolInformationResult;
        } catch (error) {

        }
    };
}

export const RETRIEVE_SCHOOLS_SUMMARY_IN_PROGRESS = "RETRIEVE_SCHOOLS_SUMMARY_IN_PROGRESS"
export const RETRIEVE_SCHOOLS_SUMMARY_COMPLETE = "RETRIEVE_SCHOOLS_SUMMARY_COMPLETE"
export const retrieveSchoolsSummaryInProgress = () => {
    return {
        type: RETRIEVE_SCHOOLS_SUMMARY_IN_PROGRESS
    };
};

export const retrieveSchoolsSummaryComplete = data => {
    return {
        type: RETRIEVE_SCHOOLS_SUMMARY_COMPLETE,
        data: data
    };
};


export const getSchoolsSummary = (ownerId) => {
    return async dispatch => {
        try {
            dispatch(retrieveSchoolsSummaryInProgress());
            let url = APIDirectory.getSchoolsSummaryURL(ownerId);
            let schoolsSummary = await HTTP.GET(url);
            dispatch(retrieveSchoolsSummaryComplete(schoolsSummary));
            return schoolsSummary
        }
        catch (error) {
            console.log(error)
            return [];
        }
    };
};

export const GET_SCHOOL_INFORMATION_BY_ID_IN_PROGRESS = "GET_SCHOOL_INFORMATION_BY_ID_IN_PROGRESS"
export const GET_SCHOOL_INFORMATION_BY_ID_COMPLETE = "GET_SCHOOL_INFORMATION_BY_ID_COMPLETE"

export const getSchoolInformationByIdInProgress = () => {
    return {
        type: GET_SCHOOL_INFORMATION_BY_ID_IN_PROGRESS
    };
};

export const getSchoolInformationByIdComplete = data => {
    return {
        type: GET_SCHOOL_INFORMATION_BY_ID_COMPLETE,
        data: data
    };
};

export const getSchoolInformationById = (schoolId) => {
    return async dispatch => {
        try {
            dispatch(getSchoolInformationByIdInProgress());
            let url = APIDirectory.getSchoolInformationByIdURL(schoolId);
            const start = new Date();
            let school = await HTTP.GET(url);
            resetActiveSchool(school);
            const timeTaken = (new Date()) - start;
            dispatch(getSchoolInformationByIdComplete(school));
            return school;
        } catch (error) {
            throw error
        }
    }
}
export const setActiveSchedule = data => {
    return {
        type: SET_ACTIVE_SCHEDULE,
        data: data
    };
};

export const VERIFY_TIMETABLE_BY_SCHOOL_ID_IN_PROGRESS = "VERIFY_TIMETABLE_BY_SCHOOL_ID_IN_PROGRESS"
export const VERIFY_TIMETABLE_BY_SCHOOL_ID_COMPLETE = "VERIFY_TIMETABLE_BY_SCHOOL_ID_COMPLETE"
export const VERIFY_TIMETABLE_BY_SCHOOL_ID_FAILED = "VERIFY_TIMETABLE_BY_SCHOOL_ID_FAILED"
export const verifyTimeTableBySchoolIdInProgress = () => {
    return {
        type: VERIFY_TIMETABLE_BY_SCHOOL_ID_IN_PROGRESS
    };
};
export const verifyTimeTableBySchoolIdComplete = data => {
    return {
        type: VERIFY_TIMETABLE_BY_SCHOOL_ID_COMPLETE,
        data: data
    };
};
export const verifyTimeTableBySchoolIdFailed = (error) => {
    return {
        type: VERIFY_TIMETABLE_BY_SCHOOL_ID_FAILED,
        data: error
    };
};

export const verifyTimeTable = (ownerId, ownerEmail, activeSchool, scheduleIndex, scheduleId) => {
    return async dispatch => {
        try {
            dispatch(verifyTimeTableBySchoolIdInProgress());
            let url = APIDirectory.verifyTimeTableBySchoolIdUrl(ownerId, activeSchool['_id']);
            let response = await HTTP.POST(url, { scheduleId: scheduleId, school: activeSchool, userEmail: ownerEmail });
            
            console.log(response)
            //activeSchool.schedule_constraints[scheduleIndex] = response.scheduleConstraints;
            let index = lodash.findIndex(response.school.schedule_constraints,  ['_id', response.scheduleConstraints['_id']]);
            [response.school.schedule_constraints[index], response.school.schedule_constraints[scheduleIndex]] = [response.school.schedule_constraints[scheduleIndex], response.school.schedule_constraints[index]];
            dispatch(verifyTimeTableBySchoolIdComplete(response.school));
            //dispatch(setActiveSchedule({index:index,id:response.school.schedule_constraints[index]['_id']}))
            dispatch(ErrorLogActions.setActiveErrorItem({}, null))
            return response;
        } catch (error) {
            dispatch(verifyTimeTableBySchoolIdFailed(error));
            throw error
        }
    }
}



export const GENERATE_TIMETABLE_BY_SCHOOL_ID_IN_PROGRESS = "GENERATE_TIMETABLE_BY_SCHOOL_ID_IN_PROGRESS"
export const GENERATE_TIMETABLE_BY_SCHOOL_ID_COMPLETE = "GENERATE_TIMETABLE_BY_SCHOOL_ID_COMPLETE"
export const GENERATE_TIMETABLE_BY_SCHOOL_ID_FAILED = "GENERATE_TIMETABLE_BY_SCHOOL_ID_FAILED"
export const generateTimeTableBySchoolIdInProgress = () => {
    return {
        type: GENERATE_TIMETABLE_BY_SCHOOL_ID_IN_PROGRESS
    };
};
export const generateTimeTableBySchoolIdComplete = data => {
    return {
        type: GENERATE_TIMETABLE_BY_SCHOOL_ID_COMPLETE,
        data: data
    };
};
export const generateTimeTableBySchoolIdFailed = (error) => {
    return {
        type: VERIFY_TIMETABLE_BY_SCHOOL_ID_IN_PROGRESS,
        data: error
    };
};

export const generateTimeTable = (ownerId, ownerEmail, activeSchool, scheduleIndex) => {
    return async dispatch => {
        try {
            dispatch(generateTimeTableBySchoolIdInProgress());
            let scheduleConstraints = activeSchool.schedule_constraints[scheduleIndex];
            scheduleConstraints.status = ScheduleConstants.VERIFIED;
            scheduleConstraints.enableGenerateTimeTable = false
            activeSchool.schedule_constraints[scheduleIndex] = scheduleConstraints;
            let url = APIDirectory.generateTimeTableBySchoolIdUrl(ownerId, activeSchool['_id']);
            activeSchool = await HTTP.POST(url, { scheduleConstraints: scheduleConstraints, school: JSON.stringify(activeSchool), scheduleIndex: scheduleIndex, userEmail: ownerEmail });
            dispatch(generateTimeTableBySchoolIdComplete(activeSchool));
        } catch (error) {
            dispatch(generateTimeTableBySchoolIdFailed(error));
            throw error
        }
    }
}

export const deleteSchoolInProgress = () => {
    return {
        type: DELETE_SCHOOL_IN_PROGRESS
    }
}

export const deleteSchoolComplete = () => {
    return {
        type: DELETE_SCHOOL_COMPLETE,
    }
}

export const deleteSchool = (ownerId, schoolId) => {
    return async dispatch => {
        try {
            dispatch(deleteSchoolInProgress());
            let url = APIDirectory.getDeleteSchoolURL(ownerId, schoolId);
            
            let response = await HTTP.DELETE(url);
            dispatch(deleteSchoolComplete)
            dispatch(getSchoolsSummary(ownerId));

            return response;
        } catch (error) {
            console.error("Schoolinformation action error ->", error);
            dispatch(deleteSchoolComplete)
            return { result: error, status: false };
        }
    }
}